export const REPORT_BUTTON = 'REPORT_BUTTON';
export const PREDEFINED_QUESTIONS = 'PREDEFINED_QUESTIONS';
export const EXCLUDED_FILTER = 'timeframe_granularity';
export const accountLanguage = 'en';
export const wwwWix = 'https://www.wix.com';
export const manageWix = 'https://manage.wix.com';
export const bo = 'https://bo.wix.com';
//# sourceMappingURL=constants.js.map